export default {
    brand: {
      "brandId" : "9bad8fdc-b5f0-44ee-90c9-63924999d3f0",
      "brandName" : "Dr. Brandt",
      "brandSlug" : "dr-brandt",
      "cartLink" : "https://www.drbrandtskincare.com/cart",
      "cartName" : "Dr. Brandt",
      "cartPlatform" : "shopify",
      "category" : "beauty",
      "modified_at" : "Thu Jun 15 2017 10:32:43 GMT-0400 (EDT)",
      "modified_by" : "adam@mikmak.tv",
      "tracking" : "(function (url) { /*Tracking Bootstrap Set Up DataLayer objects/properties here*/ if(!window.DataLayer){ window.DataLayer = {}; } if(!DataLayer.events){ DataLayer.events = {}; } DataLayer.events.SiteSection = \"1\"; var loc, ct = document.createElement(\"script\");  ct.type = \"text/javascript\";  ct.async = true; ct.src = url; loc = document.getElementsByTagName(\"script\")[0]; loc.parentNode.insertBefore(ct, loc); }(document.location.protocol + \"//js.rmtag.com/112215.ct.js\"));",
      "trackingPixel" : "//nypi.dc-storm.com/dcv4/logi.aspx?tsid=1030357&sid=112215&acid=109155&crf=54823&agrf=548233739637&adrf=16157250&rnd=[cachebuster]",
      "utmParameters" : "?mikmakAttach=true&mikmakUserId=USER+ID+HERE&rmatt=tsid:1030357|cid:54823|cgid:548233739637|crid:16157250"
    },
    products: [
      {
        "cartMetadata" : {
          "addToCartUrl" : "https://www.drbrandtskincare.com/cart/add.js",
          "hiddenInputs" : [ {
            "class" : "original_select_8705460941",
            "data-productid" : "8705460941",
            "name" : "id",
            "value" : "29782738573"
          } ]
        },
        "productUrl" : "https://www.drbrandtskincare.com/products/pores-no-more-multi-performance-stick",
        "name" : "pores no more",
        "price" : "35.00",
        "product-images" : [ "//cdn.shopify.com/s/files/1/1347/3227/products/multi-performance-stick_dt_1024x1024.jpg?v=1483975654" ],
        "slug" : "pores-no-more"
      }
    ]
  }



// WEBPACK FOOTER //
// ./client/store/products/poresnomore.js